import cn from 'classnames';

interface DividerProps {
  className?: string;
}

export const Divider = ({ className }: DividerProps) => (
  <div className={cn('w-full py-[1px] bg-[#F0F0F0]', className)} />
);
